import * as angular from 'angular';
import * as $ocLazyLoad from 'oclazyload';
import { AccountSetupWizardViewComponent } from './account-setup/account-setup-wizard-view.component';
import { ActivityEditorWizardViewComponent } from './activity-editor-wizard-view/activity-editor-wizard-view.component';
import { CoursePaymentWizardViewComponent } from './course-payment/course-payment-wizard-view.component';
import { CourseSetupWizardViewComponent } from './course-setup/course-setup-wizard-view.component';
import { QuickStartGuideWizardViewComponent } from './quick-start-guide/quick-start-guide-wizard-view.component';
import { appDataModule } from '../../app-data';
import { courseEditorModule } from 'go-modules/course-editor';
import { goPubnubModule } from 'go-modules/go-pubnub';
import { richDropdownModule } from 'go-modules/rich-dropdown';
import { activityEditorModule } from 'go-modules/activity-editor';
import { lazyPaymentPanelModule } from 'go-modules/payment-panel/lazy-index';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { ngxActiveBrandServiceModule } from '@go-modules/services/active-brand';
import { fullstoryModule } from 'go-modules/services/fullstory';
import { ngxGroupServiceModule } from '@go-modules/services/group';
import { ChoosePlanWizardViewComponent } from './choose-plan/choose-plan-wizard-view.component';
import { LicensePaymentWizardViewComponent } from './license-payment/license-payment-wizard-view.component';
import { paymentPanelModule } from 'go-modules/payment-panel';
import { ngxWizardViewModule } from '@lti/app/wizards';
import { ngxCourseServiceModule } from '@go-modules/services/course';
import { ngxAppDataServiceModule } from '@go-modules/services/app-data';
import { ngxCoursePaymentWallModule } from '@go-modules/components/course-payment-wall';
import {
	ngxActivityPreviewEditorDialogServiceModule
} from '@go-modules/components/dialogs/activity-preview-editor';

export const wizardViewModule = angular
	.module('wizard-view', [
		appDataModule.name,
		courseEditorModule,
		ngxFeatureFlagServiceModule,
		ngxActiveBrandServiceModule,
		goPubnubModule,
		richDropdownModule,
		$ocLazyLoad as unknown as string,
		paymentPanelModule.name,
		lazyPaymentPanelModule,
		activityEditorModule.name,
		fullstoryModule,
		ngxGroupServiceModule,
		ngxWizardViewModule,
		ngxCourseServiceModule,
		ngxAppDataServiceModule,
		ngxCoursePaymentWallModule,
		ngxActivityPreviewEditorDialogServiceModule
	])
	.component('accountSetupWizardView', AccountSetupWizardViewComponent)
	.component('activityEditorWizardView', ActivityEditorWizardViewComponent)
	.component('coursePaymentWizardView', CoursePaymentWizardViewComponent)
	.component('courseSetupWizardView', CourseSetupWizardViewComponent)
	.component('quickStartGuideWizardView', QuickStartGuideWizardViewComponent)
	.component('choosePlanWizardView', ChoosePlanWizardViewComponent)
	.component('licensePaymentWizardView', LicensePaymentWizardViewComponent)
	.name;
